module.exports = __webpack_public_path__ + "static/media/general-electric-white.05af26bf.svg";